import {useFlags, useLDClient} from 'launchdarkly-react-client-sdk';
import React from 'react';

import type {ComponentType} from 'react';
import type {LDProps} from 'types/launch-darkly-types';

/**
 * Wrapper component that supplies LaunchDarkly flags and the LaunchDarkly client to the wrapped component by calling `useFlags`
 * and `useLDClient` internally. This is an alternative to wrapping a legacy class component with the `withLDConsumer` HOC,
 * which cannot be mocked with the `jest-launchdarkly-mock` library. Replacing `withLDConsumer` with this allows the wrapped
 * component to be tested with mock values for the flags, without having to rewrite the whole component to be functional.
 */
export default <P extends object>(WrappedComponent: ComponentType<P & LDProps>) => {
    return React.forwardRef<ComponentType<P>, P>((props: P, ref) => {
        const ldClient = useLDClient();
        const flags = useFlags();
        return <WrappedComponent {...props} flags={flags} ldClient={ldClient} ref={ref} />;
    });
};
